// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import Base64 from 'js-base64'

Vue.use(ElementUI);
Vue.use(Base64);

Vue.prototype.$api = require('./assets/js/api/common.js').default;
Vue.prototype.$util = require('./assets/js/util/util.js').default;
Vue.prototype.$config = require('./assets/js/config.js').default;
Vue.prototype.$layer = layer(Vue, {
  msgtime: 2,//目前只有一项，即msg方法的默认消失时间，单位：秒
});


import Upload from './components/Upload.vue'
Vue.component('Upload',Upload)
import MoreImage from './components/MoreImage.vue'
Vue.component('MoreImage',MoreImage)
import Editor from './components/Editor.vue'
Vue.component('Editor',Editor)
import CPrice from './components/CPrice.vue'
Vue.component('CPrice',CPrice)
import FileSize from './components/FileSize.vue'
Vue.component('FileSize',FileSize)
import LinkSelect from './components/LinkSelect.vue'
Vue.component('SelectLink',LinkSelect)
import ConfigBoxTitle from './components/ConfigBoxTitle.vue'
Vue.component('ConfigBoxTitle',ConfigBoxTitle)
import FormLine from './components/FormLine.vue'
Vue.component('FormLine',FormLine)
import SelectItem from './components/SelectItem.vue'
Vue.component('SelectItem',SelectItem)

import AmapVue from '@amap/amap-vue';
AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
AmapVue.config.key = 'aa8b4409a8723c98676b0cb4bdb445fb';
AmapVue.config.plugins = [
  // 在此配置你需要预加载的插件，如果不配置，在使用到的时候会自动异步加载
];
Vue.use(AmapVue);

import store from './store/store'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js